import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createFeature } from "./planFeatureAPI"; // Make sure to also rename this file/module if necessary

const initialState = {
  designation: "",
  loading: "idle",
  features: [],
  feature: { designation: "" },
  totalPages: 0,
  allFeatures: {
    features: [],
    totalCount: 0,
    totalPages: 0,
    currentPage: 1,
  },
};

export const addFeature = createAsyncThunk("feature/addFeature", async (data: any) => {
  return await createFeature.add(data);
});

export const fetchFeatures = createAsyncThunk("feature/fetchFeatures", async () => {
  return await createFeature.fetchFeatures();
});

export const deleteFeature = createAsyncThunk("feature/deleteFeature", async (id: number) => {
  return await createFeature.delete(id);
});

export const updateFeature = createAsyncThunk(
  "feature/updateFeature",
  async ({ data, id }: { data: any; id: any }) => {
    return await createFeature.update(data, id);
  }
);

export const getFeatureById = createAsyncThunk("feature/getFeatureById", async (id: any) => {
  return await createFeature.getById(id);
});

export const adminGetAllFeatures = createAsyncThunk(
  "adminGetAllFeatures",
  async ({ page, searchTerm }: { page: number; searchTerm: string }) => {
    return await createFeature.adminGetAllFeatures(page, searchTerm);
  }
);

const featureSlice = createSlice({
  name: "feature",
  initialState,
  reducers: {
    setDesignation(state, action) {
      state.designation = action.payload;
    },
    resetDesignation(state) {
      state.designation = "";
    },
    resetValues(state) {
      state.designation = "";
      state.loading = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addFeature.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(addFeature.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.designation = action.payload;
      })
      .addCase(addFeature.rejected, (state) => {
        state.loading = "failed";
      });

    builder.addCase(fetchFeatures.fulfilled, (state, action) => {
      state.features = action.payload;
    });

    builder
      .addCase(adminGetAllFeatures.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(adminGetAllFeatures.fulfilled, (state, action) => {
        state.allFeatures = {
          features: action.payload.features || [],
          totalCount: action.payload.totalCount || 0,
          totalPages: action.payload.totalPages || 0,
          currentPage: action.payload.currentPage || 1,
        };
        state.loading = "succeeded";
      })
      .addCase(adminGetAllFeatures.rejected, (state) => {
        state.loading = "failed";
      });

    builder
      .addCase(deleteFeature.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(deleteFeature.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(deleteFeature.rejected, (state) => {
        state.loading = "failed";
      });

    builder
      .addCase(updateFeature.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(updateFeature.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.designation = action.payload;
      })
      .addCase(updateFeature.rejected, (state) => {
        state.loading = "failed";
      });

    builder.addCase(getFeatureById.fulfilled, (state, action) => {
      state.feature = action.payload;
    });
  },
});

export const { setDesignation, resetDesignation, resetValues } = featureSlice.actions;
export default featureSlice.reducer;
